// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetSpotV3PublicSymbols (params?: {}): Promise<Dict>;
    publicGetSpotV3PublicQuoteDepth (params?: {}): Promise<Dict>;
    publicGetSpotV3PublicQuoteDepthMerged (params?: {}): Promise<Dict>;
    publicGetSpotV3PublicQuoteTrades (params?: {}): Promise<Dict>;
    publicGetSpotV3PublicQuoteKline (params?: {}): Promise<Dict>;
    publicGetSpotV3PublicQuoteTicker24hr (params?: {}): Promise<Dict>;
    publicGetSpotV3PublicQuoteTickerPrice (params?: {}): Promise<Dict>;
    publicGetSpotV3PublicQuoteTickerBookTicker (params?: {}): Promise<Dict>;
    publicGetSpotV3PublicServerTime (params?: {}): Promise<Dict>;
    publicGetSpotV3PublicInfos (params?: {}): Promise<Dict>;
    publicGetSpotV3PublicMarginProductInfos (params?: {}): Promise<Dict>;
    publicGetSpotV3PublicMarginEnsureTokens (params?: {}): Promise<Dict>;
    publicGetV3PublicTime (params?: {}): Promise<Dict>;
    publicGetContractV3PublicCopytradingSymbolList (params?: {}): Promise<Dict>;
    publicGetDerivativesV3PublicOrderBookL2 (params?: {}): Promise<Dict>;
    publicGetDerivativesV3PublicKline (params?: {}): Promise<Dict>;
    publicGetDerivativesV3PublicTickers (params?: {}): Promise<Dict>;
    publicGetDerivativesV3PublicInstrumentsInfo (params?: {}): Promise<Dict>;
    publicGetDerivativesV3PublicMarkPriceKline (params?: {}): Promise<Dict>;
    publicGetDerivativesV3PublicIndexPriceKline (params?: {}): Promise<Dict>;
    publicGetDerivativesV3PublicFundingHistoryFundingRate (params?: {}): Promise<Dict>;
    publicGetDerivativesV3PublicRiskLimitList (params?: {}): Promise<Dict>;
    publicGetDerivativesV3PublicDeliveryPrice (params?: {}): Promise<Dict>;
    publicGetDerivativesV3PublicRecentTrade (params?: {}): Promise<Dict>;
    publicGetDerivativesV3PublicOpenInterest (params?: {}): Promise<Dict>;
    publicGetDerivativesV3PublicInsurance (params?: {}): Promise<Dict>;
    publicGetV5AnnouncementsIndex (params?: {}): Promise<Dict>;
    publicGetV5SystemStatus (params?: {}): Promise<Dict>;
    publicGetV5MarketTime (params?: {}): Promise<Dict>;
    publicGetV5MarketKline (params?: {}): Promise<Dict>;
    publicGetV5MarketMarkPriceKline (params?: {}): Promise<Dict>;
    publicGetV5MarketIndexPriceKline (params?: {}): Promise<Dict>;
    publicGetV5MarketPremiumIndexPriceKline (params?: {}): Promise<Dict>;
    publicGetV5MarketInstrumentsInfo (params?: {}): Promise<Dict>;
    publicGetV5MarketOrderbook (params?: {}): Promise<Dict>;
    publicGetV5MarketRpiOrderbook (params?: {}): Promise<Dict>;
    publicGetV5MarketFullOrderbook (params?: {}): Promise<Dict>;
    publicGetV5MarketTickers (params?: {}): Promise<Dict>;
    publicGetV5MarketFundingHistory (params?: {}): Promise<Dict>;
    publicGetV5MarketRecentTrade (params?: {}): Promise<Dict>;
    publicGetV5MarketOpenInterest (params?: {}): Promise<Dict>;
    publicGetV5MarketHistoricalVolatility (params?: {}): Promise<Dict>;
    publicGetV5MarketInsurance (params?: {}): Promise<Dict>;
    publicGetV5MarketRiskLimit (params?: {}): Promise<Dict>;
    publicGetV5MarketDeliveryPrice (params?: {}): Promise<Dict>;
    publicGetV5MarketNewDeliveryPrice (params?: {}): Promise<Dict>;
    publicGetV5MarketAccountRatio (params?: {}): Promise<Dict>;
    publicGetV5MarketIndexPriceComponents (params?: {}): Promise<Dict>;
    publicGetV5MarketPriceLimit (params?: {}): Promise<Dict>;
    publicGetV5MarketAdlAlert (params?: {}): Promise<Dict>;
    publicGetV5MarketFeeGroupInfo (params?: {}): Promise<Dict>;
    publicGetV5SpotLeverTokenInfo (params?: {}): Promise<Dict>;
    publicGetV5SpotLeverTokenReference (params?: {}): Promise<Dict>;
    publicGetV5SpotMarginTradeData (params?: {}): Promise<Dict>;
    publicGetV5SpotMarginTradeCollateral (params?: {}): Promise<Dict>;
    publicGetV5SpotCrossMarginTradeData (params?: {}): Promise<Dict>;
    publicGetV5SpotCrossMarginTradePledgeToken (params?: {}): Promise<Dict>;
    publicGetV5SpotCrossMarginTradeBorrowToken (params?: {}): Promise<Dict>;
    publicGetV5CryptoLoanCollateralData (params?: {}): Promise<Dict>;
    publicGetV5CryptoLoanLoanableData (params?: {}): Promise<Dict>;
    publicGetV5CryptoLoanCommonLoanableData (params?: {}): Promise<Dict>;
    publicGetV5CryptoLoanCommonCollateralData (params?: {}): Promise<Dict>;
    publicGetV5CryptoLoanFixedSupplyOrderQuote (params?: {}): Promise<Dict>;
    publicGetV5CryptoLoanFixedBorrowOrderQuote (params?: {}): Promise<Dict>;
    publicGetV5InsLoanProductInfos (params?: {}): Promise<Dict>;
    publicGetV5InsLoanEnsureTokensConvert (params?: {}): Promise<Dict>;
    publicGetV5EarnProduct (params?: {}): Promise<Dict>;
    privateGetV5MarketInstrumentsInfo (params?: {}): Promise<Dict>;
    privateGetV2PrivateWalletFundRecords (params?: {}): Promise<Dict>;
    privateGetSpotV3PrivateOrder (params?: {}): Promise<Dict>;
    privateGetSpotV3PrivateOpenOrders (params?: {}): Promise<Dict>;
    privateGetSpotV3PrivateHistoryOrders (params?: {}): Promise<Dict>;
    privateGetSpotV3PrivateMyTrades (params?: {}): Promise<Dict>;
    privateGetSpotV3PrivateAccount (params?: {}): Promise<Dict>;
    privateGetSpotV3PrivateReference (params?: {}): Promise<Dict>;
    privateGetSpotV3PrivateRecord (params?: {}): Promise<Dict>;
    privateGetSpotV3PrivateCrossMarginOrders (params?: {}): Promise<Dict>;
    privateGetSpotV3PrivateCrossMarginAccount (params?: {}): Promise<Dict>;
    privateGetSpotV3PrivateCrossMarginLoanInfo (params?: {}): Promise<Dict>;
    privateGetSpotV3PrivateCrossMarginRepayHistory (params?: {}): Promise<Dict>;
    privateGetSpotV3PrivateMarginLoanInfos (params?: {}): Promise<Dict>;
    privateGetSpotV3PrivateMarginRepaidInfos (params?: {}): Promise<Dict>;
    privateGetSpotV3PrivateMarginLtv (params?: {}): Promise<Dict>;
    privateGetAssetV3PrivateTransferInterTransferListQuery (params?: {}): Promise<Dict>;
    privateGetAssetV3PrivateTransferSubMemberListQuery (params?: {}): Promise<Dict>;
    privateGetAssetV3PrivateTransferSubMemberTransferListQuery (params?: {}): Promise<Dict>;
    privateGetAssetV3PrivateTransferUniversalTransferListQuery (params?: {}): Promise<Dict>;
    privateGetAssetV3PrivateCoinInfoQuery (params?: {}): Promise<Dict>;
    privateGetAssetV3PrivateDepositAddressQuery (params?: {}): Promise<Dict>;
    privateGetContractV3PrivateCopytradingOrderList (params?: {}): Promise<Dict>;
    privateGetContractV3PrivateCopytradingPositionList (params?: {}): Promise<Dict>;
    privateGetContractV3PrivateCopytradingWalletBalance (params?: {}): Promise<Dict>;
    privateGetContractV3PrivatePositionLimitInfo (params?: {}): Promise<Dict>;
    privateGetContractV3PrivateOrderUnfilledOrders (params?: {}): Promise<Dict>;
    privateGetContractV3PrivateOrderList (params?: {}): Promise<Dict>;
    privateGetContractV3PrivatePositionList (params?: {}): Promise<Dict>;
    privateGetContractV3PrivateExecutionList (params?: {}): Promise<Dict>;
    privateGetContractV3PrivatePositionClosedPnl (params?: {}): Promise<Dict>;
    privateGetContractV3PrivateAccountWalletBalance (params?: {}): Promise<Dict>;
    privateGetContractV3PrivateAccountFeeRate (params?: {}): Promise<Dict>;
    privateGetContractV3PrivateAccountWalletFundRecords (params?: {}): Promise<Dict>;
    privateGetUnifiedV3PrivateOrderUnfilledOrders (params?: {}): Promise<Dict>;
    privateGetUnifiedV3PrivateOrderList (params?: {}): Promise<Dict>;
    privateGetUnifiedV3PrivatePositionList (params?: {}): Promise<Dict>;
    privateGetUnifiedV3PrivateExecutionList (params?: {}): Promise<Dict>;
    privateGetUnifiedV3PrivateDeliveryRecord (params?: {}): Promise<Dict>;
    privateGetUnifiedV3PrivateSettlementRecord (params?: {}): Promise<Dict>;
    privateGetUnifiedV3PrivateAccountWalletBalance (params?: {}): Promise<Dict>;
    privateGetUnifiedV3PrivateAccountTransactionLog (params?: {}): Promise<Dict>;
    privateGetUnifiedV3PrivateAccountBorrowHistory (params?: {}): Promise<Dict>;
    privateGetUnifiedV3PrivateAccountBorrowRate (params?: {}): Promise<Dict>;
    privateGetUnifiedV3PrivateAccountInfo (params?: {}): Promise<Dict>;
    privateGetUserV3PrivateFrozenSubMember (params?: {}): Promise<Dict>;
    privateGetUserV3PrivateQuerySubMembers (params?: {}): Promise<Dict>;
    privateGetUserV3PrivateQueryApi (params?: {}): Promise<Dict>;
    privateGetUserV3PrivateGetMemberType (params?: {}): Promise<Dict>;
    privateGetAssetV3PrivateTransferTransferCoinListQuery (params?: {}): Promise<Dict>;
    privateGetAssetV3PrivateTransferAccountCoinBalanceQuery (params?: {}): Promise<Dict>;
    privateGetAssetV3PrivateTransferAccountCoinsBalanceQuery (params?: {}): Promise<Dict>;
    privateGetAssetV3PrivateTransferAssetInfoQuery (params?: {}): Promise<Dict>;
    privateGetAssetV3PublicDepositAllowedDepositListQuery (params?: {}): Promise<Dict>;
    privateGetAssetV3PrivateDepositRecordQuery (params?: {}): Promise<Dict>;
    privateGetAssetV3PrivateWithdrawRecordQuery (params?: {}): Promise<Dict>;
    privateGetV5OrderRealtime (params?: {}): Promise<Dict>;
    privateGetV5OrderHistory (params?: {}): Promise<Dict>;
    privateGetV5OrderSpotBorrowCheck (params?: {}): Promise<Dict>;
    privateGetV5PositionList (params?: {}): Promise<Dict>;
    privateGetV5ExecutionList (params?: {}): Promise<Dict>;
    privateGetV5PositionClosedPnl (params?: {}): Promise<Dict>;
    privateGetV5PositionGetClosedPositions (params?: {}): Promise<Dict>;
    privateGetV5PositionMoveHistory (params?: {}): Promise<Dict>;
    privateGetV5PositionSymbolInfo (params?: {}): Promise<Dict>;
    privateGetV5PreUpgradeOrderHistory (params?: {}): Promise<Dict>;
    privateGetV5PreUpgradeExecutionList (params?: {}): Promise<Dict>;
    privateGetV5PreUpgradePositionClosedPnl (params?: {}): Promise<Dict>;
    privateGetV5PreUpgradeAccountTransactionLog (params?: {}): Promise<Dict>;
    privateGetV5PreUpgradeAssetDeliveryRecord (params?: {}): Promise<Dict>;
    privateGetV5PreUpgradeAssetSettlementRecord (params?: {}): Promise<Dict>;
    privateGetV5AccountWalletBalance (params?: {}): Promise<Dict>;
    privateGetV5AccountBorrowHistory (params?: {}): Promise<Dict>;
    privateGetV5AccountInstrumentsInfo (params?: {}): Promise<Dict>;
    privateGetV5AccountCollateralInfo (params?: {}): Promise<Dict>;
    privateGetV5AccountOptionAssetInfo (params?: {}): Promise<Dict>;
    privateGetV5AssetCoinGreeks (params?: {}): Promise<Dict>;
    privateGetV5AccountFeeRate (params?: {}): Promise<Dict>;
    privateGetV5AccountInfo (params?: {}): Promise<Dict>;
    privateGetV5AccountTransactionLog (params?: {}): Promise<Dict>;
    privateGetV5AccountContractTransactionLog (params?: {}): Promise<Dict>;
    privateGetV5AccountQueryDcpInfo (params?: {}): Promise<Dict>;
    privateGetV5AccountUserSettingConfig (params?: {}): Promise<Dict>;
    privateGetV5AccountPayInfo (params?: {}): Promise<Dict>;
    privateGetV5AccountTradeInfoForAnalysis (params?: {}): Promise<Dict>;
    privateGetV5AccountSmpGroup (params?: {}): Promise<Dict>;
    privateGetV5AccountMmpState (params?: {}): Promise<Dict>;
    privateGetV5AccountWithdrawal (params?: {}): Promise<Dict>;
    privateGetV5AssetAssetOverview (params?: {}): Promise<Dict>;
    privateGetV5AssetExchangeQueryCoinList (params?: {}): Promise<Dict>;
    privateGetV5AssetExchangeConvertResultQuery (params?: {}): Promise<Dict>;
    privateGetV5AssetExchangeQueryConvertHistory (params?: {}): Promise<Dict>;
    privateGetV5AssetExchangeOrderRecord (params?: {}): Promise<Dict>;
    privateGetV5AssetFundinghistory (params?: {}): Promise<Dict>;
    privateGetV5AssetPortfolioMargin (params?: {}): Promise<Dict>;
    privateGetV5AssetTotalMembersAssets (params?: {}): Promise<Dict>;
    privateGetV5AssetDeliveryRecord (params?: {}): Promise<Dict>;
    privateGetV5AssetSettlementRecord (params?: {}): Promise<Dict>;
    privateGetV5AssetTransferQueryAssetInfo (params?: {}): Promise<Dict>;
    privateGetV5AssetTransferQueryAccountCoinsBalance (params?: {}): Promise<Dict>;
    privateGetV5AssetTransferQueryAccountCoinBalance (params?: {}): Promise<Dict>;
    privateGetV5AssetTransferQueryTransferCoinList (params?: {}): Promise<Dict>;
    privateGetV5AssetTransferQueryInterTransferList (params?: {}): Promise<Dict>;
    privateGetV5AssetTransferQuerySubMemberList (params?: {}): Promise<Dict>;
    privateGetV5AssetTransferQueryUniversalTransferList (params?: {}): Promise<Dict>;
    privateGetV5AssetDepositQueryAllowedList (params?: {}): Promise<Dict>;
    privateGetV5AssetDepositQueryRecord (params?: {}): Promise<Dict>;
    privateGetV5AssetDepositQuerySubMemberRecord (params?: {}): Promise<Dict>;
    privateGetV5AssetDepositQueryInternalRecord (params?: {}): Promise<Dict>;
    privateGetV5AssetDepositQueryAddress (params?: {}): Promise<Dict>;
    privateGetV5AssetDepositQuerySubMemberAddress (params?: {}): Promise<Dict>;
    privateGetV5AssetCoinQueryInfo (params?: {}): Promise<Dict>;
    privateGetV5AssetWithdrawQueryAddress (params?: {}): Promise<Dict>;
    privateGetV5AssetWithdrawQueryRecord (params?: {}): Promise<Dict>;
    privateGetV5AssetWithdrawWithdrawableAmount (params?: {}): Promise<Dict>;
    privateGetV5AssetWithdrawVaspList (params?: {}): Promise<Dict>;
    privateGetV5AssetCovertSmallBalanceList (params?: {}): Promise<Dict>;
    privateGetV5AssetCovertSmallBalanceHistory (params?: {}): Promise<Dict>;
    privateGetV5AssetConvertSmallBalanceList (params?: {}): Promise<Dict>;
    privateGetV5AssetConvertSmallBalanceHistory (params?: {}): Promise<Dict>;
    privateGetV5FiatQueryCoinList (params?: {}): Promise<Dict>;
    privateGetV5FiatReferencePrice (params?: {}): Promise<Dict>;
    privateGetV5FiatTradeQuery (params?: {}): Promise<Dict>;
    privateGetV5FiatQueryTradeHistory (params?: {}): Promise<Dict>;
    privateGetV5FiatBalanceQuery (params?: {}): Promise<Dict>;
    privateGetV5UserQuerySubMembers (params?: {}): Promise<Dict>;
    privateGetV5UserQueryApi (params?: {}): Promise<Dict>;
    privateGetV5UserSubApikeys (params?: {}): Promise<Dict>;
    privateGetV5UserGetMemberType (params?: {}): Promise<Dict>;
    privateGetV5UserAffCustomerInfo (params?: {}): Promise<Dict>;
    privateGetV5UserDelSubmember (params?: {}): Promise<Dict>;
    privateGetV5UserSubmembers (params?: {}): Promise<Dict>;
    privateGetV5UserEscrowSubMembers (params?: {}): Promise<Dict>;
    privateGetV5UserInvitationReferrals (params?: {}): Promise<Dict>;
    privateGetV5AffiliateAffUserList (params?: {}): Promise<Dict>;
    privateGetV5AffiliateAffiliateSubList (params?: {}): Promise<Dict>;
    privateGetV5SpotLeverTokenOrderRecord (params?: {}): Promise<Dict>;
    privateGetV5SpotMarginTradeFlexibleAvailableInventory (params?: {}): Promise<Dict>;
    privateGetV5SpotMarginTradeInterestRateHistory (params?: {}): Promise<Dict>;
    privateGetV5SpotMarginTradeState (params?: {}): Promise<Dict>;
    privateGetV5SpotMarginTradeMaxBorrowable (params?: {}): Promise<Dict>;
    privateGetV5SpotMarginTradePositionTiers (params?: {}): Promise<Dict>;
    privateGetV5SpotMarginTradeCoinstate (params?: {}): Promise<Dict>;
    privateGetV5SpotMarginTradeCurrencyData (params?: {}): Promise<Dict>;
    privateGetV5SpotMarginTradeFixedborrowContractInfo (params?: {}): Promise<Dict>;
    privateGetV5SpotMarginTradeFixedborrowOrderInfo (params?: {}): Promise<Dict>;
    privateGetV5SpotMarginTradeFixedborrowOrderQuote (params?: {}): Promise<Dict>;
    privateGetV5SpotMarginTradeLiability (params?: {}): Promise<Dict>;
    privateGetV5SpotMarginTradeRepaymentAvailableAmount (params?: {}): Promise<Dict>;
    privateGetV5SpotMarginTradeGetAutoRepayMode (params?: {}): Promise<Dict>;
    privateGetV5SpotCrossMarginTradeLoanInfo (params?: {}): Promise<Dict>;
    privateGetV5SpotCrossMarginTradeAccount (params?: {}): Promise<Dict>;
    privateGetV5SpotCrossMarginTradeOrders (params?: {}): Promise<Dict>;
    privateGetV5SpotCrossMarginTradeRepayHistory (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanBorrowableCollateralisableNumber (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanOngoingOrders (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanRepaymentHistory (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanBorrowHistory (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanMaxCollateralAmount (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanAdjustmentHistory (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanCommonMaxCollateralAmount (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanCommonAdjustmentHistory (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanCommonPosition (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanFlexibleOngoingCoin (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanFlexibleBorrowHistory (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanFlexibleRepaymentHistory (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanFixedBorrowContractInfo (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanFixedSupplyContractInfo (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanFixedBorrowOrderInfo (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanFixedRenewInfo (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanFixedSupplyOrderInfo (params?: {}): Promise<Dict>;
    privateGetV5CryptoLoanFixedRepaymentHistory (params?: {}): Promise<Dict>;
    privateGetV5InsLoanProductInfos (params?: {}): Promise<Dict>;
    privateGetV5InsLoanEnsureTokens (params?: {}): Promise<Dict>;
    privateGetV5InsLoanEnsureTokensConvert (params?: {}): Promise<Dict>;
    privateGetV5InsLoanLoanOrder (params?: {}): Promise<Dict>;
    privateGetV5InsLoanRepaidHistory (params?: {}): Promise<Dict>;
    privateGetV5InsLoanLtv (params?: {}): Promise<Dict>;
    privateGetV5InsLoanLtvConvert (params?: {}): Promise<Dict>;
    privateGetV5InsLoanCoinDeltaAmount (params?: {}): Promise<Dict>;
    privateGetV5LendingInfo (params?: {}): Promise<Dict>;
    privateGetV5LendingHistoryOrder (params?: {}): Promise<Dict>;
    privateGetV5LendingAccount (params?: {}): Promise<Dict>;
    privateGetV5BrokerEarningRecord (params?: {}): Promise<Dict>;
    privateGetV5BrokerEarningsInfo (params?: {}): Promise<Dict>;
    privateGetV5BrokerAccountInfo (params?: {}): Promise<Dict>;
    privateGetV5BrokerAssetQuerySubMemberDepositRecord (params?: {}): Promise<Dict>;
    privateGetV5EarnProduct (params?: {}): Promise<Dict>;
    privateGetV5EarnOrder (params?: {}): Promise<Dict>;
    privateGetV5EarnPosition (params?: {}): Promise<Dict>;
    privateGetV5EarnYield (params?: {}): Promise<Dict>;
    privateGetV5EarnHourlyYield (params?: {}): Promise<Dict>;
    privatePostSpotV3PrivateOrder (params?: {}): Promise<Dict>;
    privatePostSpotV3PrivateCancelOrder (params?: {}): Promise<Dict>;
    privatePostSpotV3PrivateCancelOrders (params?: {}): Promise<Dict>;
    privatePostSpotV3PrivateCancelOrdersByIds (params?: {}): Promise<Dict>;
    privatePostSpotV3PrivatePurchase (params?: {}): Promise<Dict>;
    privatePostSpotV3PrivateRedeem (params?: {}): Promise<Dict>;
    privatePostSpotV3PrivateCrossMarginLoan (params?: {}): Promise<Dict>;
    privatePostSpotV3PrivateCrossMarginRepay (params?: {}): Promise<Dict>;
    privatePostAssetV3PrivateTransferInterTransfer (params?: {}): Promise<Dict>;
    privatePostAssetV3PrivateWithdrawCreate (params?: {}): Promise<Dict>;
    privatePostAssetV3PrivateWithdrawCancel (params?: {}): Promise<Dict>;
    privatePostAssetV3PrivateTransferSubMemberTransfer (params?: {}): Promise<Dict>;
    privatePostAssetV3PrivateTransferTransferSubMemberSave (params?: {}): Promise<Dict>;
    privatePostAssetV3PrivateTransferUniversalTransfer (params?: {}): Promise<Dict>;
    privatePostUserV3PrivateCreateSubMember (params?: {}): Promise<Dict>;
    privatePostUserV3PrivateCreateSubApi (params?: {}): Promise<Dict>;
    privatePostUserV3PrivateUpdateApi (params?: {}): Promise<Dict>;
    privatePostUserV3PrivateDeleteApi (params?: {}): Promise<Dict>;
    privatePostUserV3PrivateUpdateSubApi (params?: {}): Promise<Dict>;
    privatePostUserV3PrivateDeleteSubApi (params?: {}): Promise<Dict>;
    privatePostContractV3PrivateCopytradingOrderCreate (params?: {}): Promise<Dict>;
    privatePostContractV3PrivateCopytradingOrderCancel (params?: {}): Promise<Dict>;
    privatePostContractV3PrivateCopytradingOrderClose (params?: {}): Promise<Dict>;
    privatePostContractV3PrivateCopytradingPositionClose (params?: {}): Promise<Dict>;
    privatePostContractV3PrivateCopytradingPositionSetLeverage (params?: {}): Promise<Dict>;
    privatePostContractV3PrivateCopytradingWalletTransfer (params?: {}): Promise<Dict>;
    privatePostContractV3PrivateCopytradingOrderTradingStop (params?: {}): Promise<Dict>;
    privatePostContractV3PrivateOrderCreate (params?: {}): Promise<Dict>;
    privatePostContractV3PrivateOrderCancel (params?: {}): Promise<Dict>;
    privatePostContractV3PrivateOrderCancelAll (params?: {}): Promise<Dict>;
    privatePostContractV3PrivateOrderReplace (params?: {}): Promise<Dict>;
    privatePostContractV3PrivatePositionSetAutoAddMargin (params?: {}): Promise<Dict>;
    privatePostContractV3PrivatePositionSwitchIsolated (params?: {}): Promise<Dict>;
    privatePostContractV3PrivatePositionSwitchMode (params?: {}): Promise<Dict>;
    privatePostContractV3PrivatePositionSwitchTpslMode (params?: {}): Promise<Dict>;
    privatePostContractV3PrivatePositionSetLeverage (params?: {}): Promise<Dict>;
    privatePostContractV3PrivatePositionTradingStop (params?: {}): Promise<Dict>;
    privatePostContractV3PrivatePositionSetRiskLimit (params?: {}): Promise<Dict>;
    privatePostContractV3PrivateAccountSetMarginMode (params?: {}): Promise<Dict>;
    privatePostUnifiedV3PrivateOrderCreate (params?: {}): Promise<Dict>;
    privatePostUnifiedV3PrivateOrderReplace (params?: {}): Promise<Dict>;
    privatePostUnifiedV3PrivateOrderCancel (params?: {}): Promise<Dict>;
    privatePostUnifiedV3PrivateOrderCreateBatch (params?: {}): Promise<Dict>;
    privatePostUnifiedV3PrivateOrderReplaceBatch (params?: {}): Promise<Dict>;
    privatePostUnifiedV3PrivateOrderCancelBatch (params?: {}): Promise<Dict>;
    privatePostUnifiedV3PrivateOrderCancelAll (params?: {}): Promise<Dict>;
    privatePostUnifiedV3PrivatePositionSetLeverage (params?: {}): Promise<Dict>;
    privatePostUnifiedV3PrivatePositionTpslSwitchMode (params?: {}): Promise<Dict>;
    privatePostUnifiedV3PrivatePositionSetRiskLimit (params?: {}): Promise<Dict>;
    privatePostUnifiedV3PrivatePositionTradingStop (params?: {}): Promise<Dict>;
    privatePostUnifiedV3PrivateAccountUpgradeUnifiedAccount (params?: {}): Promise<Dict>;
    privatePostUnifiedV3PrivateAccountSetMarginMode (params?: {}): Promise<Dict>;
    privatePostFhtComplianceTaxV3PrivateRegistertime (params?: {}): Promise<Dict>;
    privatePostFhtComplianceTaxV3PrivateCreate (params?: {}): Promise<Dict>;
    privatePostFhtComplianceTaxV3PrivateStatus (params?: {}): Promise<Dict>;
    privatePostFhtComplianceTaxV3PrivateUrl (params?: {}): Promise<Dict>;
    privatePostV5OrderCreate (params?: {}): Promise<Dict>;
    privatePostV5OrderAmend (params?: {}): Promise<Dict>;
    privatePostV5OrderCancel (params?: {}): Promise<Dict>;
    privatePostV5OrderCancelAll (params?: {}): Promise<Dict>;
    privatePostV5OrderCreateBatch (params?: {}): Promise<Dict>;
    privatePostV5OrderAmendBatch (params?: {}): Promise<Dict>;
    privatePostV5OrderCancelBatch (params?: {}): Promise<Dict>;
    privatePostV5OrderDisconnectedCancelAll (params?: {}): Promise<Dict>;
    privatePostV5OrderPreCheck (params?: {}): Promise<Dict>;
    privatePostV5PositionSetLeverage (params?: {}): Promise<Dict>;
    privatePostV5PositionSwitchIsolated (params?: {}): Promise<Dict>;
    privatePostV5PositionSetTpslMode (params?: {}): Promise<Dict>;
    privatePostV5PositionSwitchMode (params?: {}): Promise<Dict>;
    privatePostV5PositionSetRiskLimit (params?: {}): Promise<Dict>;
    privatePostV5PositionTradingStop (params?: {}): Promise<Dict>;
    privatePostV5PositionSetAutoAddMargin (params?: {}): Promise<Dict>;
    privatePostV5PositionAddMargin (params?: {}): Promise<Dict>;
    privatePostV5PositionMovePositions (params?: {}): Promise<Dict>;
    privatePostV5PositionConfirmPendingMmr (params?: {}): Promise<Dict>;
    privatePostV5AccountUpgradeToUta (params?: {}): Promise<Dict>;
    privatePostV5AccountQuickRepayment (params?: {}): Promise<Dict>;
    privatePostV5AccountSetMarginMode (params?: {}): Promise<Dict>;
    privatePostV5AccountSetHedgingMode (params?: {}): Promise<Dict>;
    privatePostV5AccountMmpModify (params?: {}): Promise<Dict>;
    privatePostV5AccountMmpReset (params?: {}): Promise<Dict>;
    privatePostV5AccountBorrow (params?: {}): Promise<Dict>;
    privatePostV5AccountRepay (params?: {}): Promise<Dict>;
    privatePostV5AccountNoConvertRepay (params?: {}): Promise<Dict>;
    privatePostV5AccountSetLimitPxAction (params?: {}): Promise<Dict>;
    privatePostV5AccountSetDeltaMode (params?: {}): Promise<Dict>;
    privatePostV5AssetExchangeQuoteApply (params?: {}): Promise<Dict>;
    privatePostV5AssetExchangeConvertExecute (params?: {}): Promise<Dict>;
    privatePostV5AssetTransferInterTransfer (params?: {}): Promise<Dict>;
    privatePostV5AssetTransferSaveTransferSubMember (params?: {}): Promise<Dict>;
    privatePostV5AssetTransferUniversalTransfer (params?: {}): Promise<Dict>;
    privatePostV5AssetDepositDepositToAccount (params?: {}): Promise<Dict>;
    privatePostV5AssetTravelRuleDepositSubmit (params?: {}): Promise<Dict>;
    privatePostV5AssetWithdrawCreate (params?: {}): Promise<Dict>;
    privatePostV5AssetWithdrawCancel (params?: {}): Promise<Dict>;
    privatePostV5AssetCovertGetQuote (params?: {}): Promise<Dict>;
    privatePostV5AssetCovertSmallBalanceExecute (params?: {}): Promise<Dict>;
    privatePostV5FiatQuoteApply (params?: {}): Promise<Dict>;
    privatePostV5FiatTradeExecute (params?: {}): Promise<Dict>;
    privatePostV5UserCreateSubMember (params?: {}): Promise<Dict>;
    privatePostV5UserCreateSubApi (params?: {}): Promise<Dict>;
    privatePostV5UserFrozenSubMember (params?: {}): Promise<Dict>;
    privatePostV5UserUpdateApi (params?: {}): Promise<Dict>;
    privatePostV5UserUpdateSubApi (params?: {}): Promise<Dict>;
    privatePostV5UserDeleteApi (params?: {}): Promise<Dict>;
    privatePostV5UserDeleteSubApi (params?: {}): Promise<Dict>;
    privatePostV5UserAgreement (params?: {}): Promise<Dict>;
    privatePostV5UserCreateDemoMember (params?: {}): Promise<Dict>;
    privatePostV5SpotLeverTokenPurchase (params?: {}): Promise<Dict>;
    privatePostV5SpotLeverTokenRedeem (params?: {}): Promise<Dict>;
    privatePostV5SpotMarginTradeSwitchMode (params?: {}): Promise<Dict>;
    privatePostV5SpotMarginTradeSetLeverage (params?: {}): Promise<Dict>;
    privatePostV5SpotMarginTradeSetAutoRepayMode (params?: {}): Promise<Dict>;
    privatePostV5SpotMarginTradeFixedborrow (params?: {}): Promise<Dict>;
    privatePostV5SpotMarginTradeFixedborrowRenew (params?: {}): Promise<Dict>;
    privatePostV5SpotCrossMarginTradeLoan (params?: {}): Promise<Dict>;
    privatePostV5SpotCrossMarginTradeRepay (params?: {}): Promise<Dict>;
    privatePostV5SpotCrossMarginTradeSwitch (params?: {}): Promise<Dict>;
    privatePostV5CryptoLoanBorrow (params?: {}): Promise<Dict>;
    privatePostV5CryptoLoanRepay (params?: {}): Promise<Dict>;
    privatePostV5CryptoLoanAdjustLtv (params?: {}): Promise<Dict>;
    privatePostV5CryptoLoanCommonAdjustLtv (params?: {}): Promise<Dict>;
    privatePostV5CryptoLoanCommonMaxLoan (params?: {}): Promise<Dict>;
    privatePostV5CryptoLoanFlexibleBorrow (params?: {}): Promise<Dict>;
    privatePostV5CryptoLoanFlexibleRepay (params?: {}): Promise<Dict>;
    privatePostV5CryptoLoanFlexibleRepayCollateral (params?: {}): Promise<Dict>;
    privatePostV5CryptoLoanFixedBorrow (params?: {}): Promise<Dict>;
    privatePostV5CryptoLoanFixedRenew (params?: {}): Promise<Dict>;
    privatePostV5CryptoLoanFixedSupply (params?: {}): Promise<Dict>;
    privatePostV5CryptoLoanFixedBorrowOrderCancel (params?: {}): Promise<Dict>;
    privatePostV5CryptoLoanFixedSupplyOrderCancel (params?: {}): Promise<Dict>;
    privatePostV5CryptoLoanFixedFullyRepay (params?: {}): Promise<Dict>;
    privatePostV5CryptoLoanFixedRepayCollateral (params?: {}): Promise<Dict>;
    privatePostV5InsLoanAssociationUid (params?: {}): Promise<Dict>;
    privatePostV5InsLoanRepayLoan (params?: {}): Promise<Dict>;
    privatePostV5LendingPurchase (params?: {}): Promise<Dict>;
    privatePostV5LendingRedeem (params?: {}): Promise<Dict>;
    privatePostV5LendingRedeemCancel (params?: {}): Promise<Dict>;
    privatePostV5AccountSetCollateralSwitch (params?: {}): Promise<Dict>;
    privatePostV5AccountSetCollateralSwitchBatch (params?: {}): Promise<Dict>;
    privatePostV5AccountDemoApplyMoney (params?: {}): Promise<Dict>;
    privatePostV5BrokerAwardInfo (params?: {}): Promise<Dict>;
    privatePostV5BrokerAwardDistributeAward (params?: {}): Promise<Dict>;
    privatePostV5BrokerAwardDistributionRecord (params?: {}): Promise<Dict>;
    privatePostV5EarnPlaceOrder (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
